import Contextmenu from "./src/index.js"

export default Contextmenu


//////////////////
// WEBPACK FOOTER
// ./~/vue-contextmenujs/index.js
// module id = 189
// module chunks = 31